<h1 data-testid="order-group-detail-heading" i18n>Bestelldetails</h1>

@if (isPending) {
  <div class="alert alert-info d-flex align-items-center" role="alert">
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    <span i18n>Ihre Bestellung wird bearbeitet …</span>
  </div>
}
@if (orderGroup?.reservationStatus === ReservationStatus.Failed) {
  <div class="alert alert-danger" role="alert" data-testid="order-group-reservation-failed">
    <div><strong i18n>Die Reservierung ist fehlgeschlagen.</strong></div>
    <!-- Backend #706: the failure's code, in words. A missing or unknown code adds no line, so
         the alert says only that it failed; the backend's prose beside the code is never shown. -->
    @if (failureText) {
      <div data-testid="order-group-reservation-failure-text">{{ failureText }}</div>
    }
    <div i18n>Ihr Warenkorb wurde beibehalten – bitte versuchen Sie es erneut.</div>
  </div>
}

<div class="card cardMeasurements">
  <div class="card-body">
    <div class="row mb-2">
      <div>
        <h5 class="card-title mb-1 d-block" i18n>
          Bestellung vom {{ orderGroup?.orderGroupDateTime | date }}
        </h5>
        <!-- Tracked by id: a poll or a re-read replaces the objects, and identity tracking
             rebuilt every order with it — dropping the positions ticked so far. -->
        @for (order of orderGroup?.orders; track order.id) {
          <app-order-group-order-item
            data-testid="order-group-order"
            [order]="order"
            [claimable]="isReserved"
            (claimed)="reload()"
          ></app-order-group-order-item>
        }
      </div>
    </div>
  </div>
</div>

<button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>Zurück</button>
